import React, {DetailedHTMLProps, ReactNode, SelectHTMLAttributes} from "react";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {UseFormRegister} from "react-hook-form/dist/types/form";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {Path} from "react-hook-form";
import EraseButton from "@components/EraseButton";
import TooltipEx from "@components/Tooltip";

export interface SelectProps<TFieldValues extends FieldValues> extends DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
    register?: UseFormRegister<TFieldValues>,
    registerOptions?: RegisterOptions,
    errors?: FieldErrors,
    name: Path<TFieldValues>,
    label?: string | ReactNode,
    children: ReactNode,
    divClass?: string,
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    onClear?: () => void,
    onToggle?: () => void,
    checked?: boolean,
    //options
}

export function Select<T extends FieldValues>(props: SelectProps<T>) {
    const {onChange, errors, name, register, registerOptions, divClass, onClear, onToggle, checked = false, ...rest} = props;
    const message: string = errors ? (errors[name!] ? errors[name]?.message : '') as string : '';
    if (!register)
        throw new Error('Non hai specificato <register>!');
    const regOpt = register(name, registerOptions);

    const LocalSelect = () => <select {...rest} {...regOpt} onChange={(e) => {
        regOpt.onChange(e); // onChange della react hook form
        if (onChange)
            onChange(e);    // onChange ausiliaria
    }}
                                      name={name} id={`${name}Select`}
                                      className={props.className ? props.className : `appearance-none block w-full px-3 py-2 
              ${onClear ? 'border-l border-y rounded-l-md' : 'border rounded-md'} 
              
              shadow-sm placeholder-gray-400 text-xs sm:text-sm
                focus:outline-none focus:ring-blue-500 focus:border-blue-500
                disabled:opacity-50
                ${errors && errors[name!] ? 'border-rose-700' : 'border-gray-300'}`}>
        {props.children}
    </select>;

    return <div className={divClass ? divClass : ''}>

        <label htmlFor={`${name}Select`} className={`block text-xs sm:text-sm font-semibold mb-1 ${props.disabled ? 'opacity-50' : ''}`}>
            {onToggle && <TooltipEx tooltip="Mostra altre opzioni"><input type="checkbox" className="mr-2" checked={checked}
                                                                          onChange={() => onToggle()}/></TooltipEx>}
            {props.label}
        </label>

        <>{!onClear &&
            <LocalSelect/>
        }
            {onClear &&
                <div className="flex">
                    <LocalSelect/>
                    <div
                        className="min-w-[30px] max-w-[30px] place-content-center inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 text-xs sm:text-sm">
                        <EraseButton onClick={onClear}/>
                    </div>
                </div>}
        </>
        {errors && errors[name!] && <p className="text-rose-700">{message}</p>}
    </div>
}

export default Select;